import { render, staticRenderFns } from "./WinnerNotificationSettings.vue?vue&type=template&id=1ef72cd3&scoped=true&"
import script from "./WinnerNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./WinnerNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./WinnerNotificationSettings.vue?vue&type=style&index=0&id=1ef72cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef72cd3",
  null
  
)

export default component.exports